import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMedicareOverviewSummaryModal = (customerID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrMedicare($customerID: String) {
        mhrMedicare(customerId: $customerID) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
      },
    },
  );

  return {
    ok: data?.mhrMedicare?.ok ?? false,
    loading,
    error: error ? 'Error loading medicare overview' : data?.mhrMedicare?.error,
    html: data?.mhrMedicare?.html,
    documentId: data?.mhrMedicare?.documentId,
    uniqueRepositoryId: data?.mhrMedicare?.uniqueRepositoryId,
  };
};
